import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { ReferenceArea } from "recharts";
import "twin.macro";

import { ClimateDataGranularity } from "@/api/climate-data/types";
import { ProtectionPeriod } from "./protection-period-list.component";

export const COLOR_PROTECTION = "#A7F3D0";

/**
 * Bandes vertes des périodes de protection à superposer sur un graphe recharts.
 * À appeler directement dans le <LineChart>/<ComposedChart> (après le CartesianGrid) :
 *   {renderProtectionAreas(periods)}
 *
 * On renvoie un tableau de <ReferenceArea> plutôt qu'un composant/Fragment :
 * recharts inspecte le type de ses enfants directs et ignorerait un wrapper.
 */
export const renderProtectionAreas = (periods: ProtectionPeriod[]) =>
  periods.map((zone, i) => (
    <ReferenceArea
      key={i}
      x1={DateTime.fromISO(zone.from).toMillis()}
      x2={DateTime.fromISO(zone.to).toMillis()}
      fill={COLOR_PROTECTION}
      fillOpacity={0.6}
      ifOverflow="extendDomain"
    />
  ));

export const ProtectionLegendItem = () => {
  const { t } = useTranslation();
  return (
    <span tw="flex items-center gap-2">
      <span
        tw="inline-block w-3 h-3 rounded-sm"
        style={{ backgroundColor: COLOR_PROTECTION }}
      />
      {t("meteo.climateView.chart.legendProtection")}
    </span>
  );
};

export const formatChartTick = (
  ts: number,
  granularity: ClimateDataGranularity
) => {
  const d = DateTime.fromMillis(ts).setLocale("fr");
  return granularity === "hour" ? d.toFormat("HH'h'") : d.toFormat("dd/MM");
};
